import { InputText } from 'primereact/inputtext';
import './styles.css';

function Input({
  htmlFor,
  id,
  name,
  type = "text",
  className = "",
  label,
  onChange,
  onBlur,
  value,
  required = false,
  placeholder,
  disabled = false,
  error,
  touched,
  helpText,
  colSpan,
  labelChildren,
  autoComplete = "off",
}) {
  const hasError = touched && !!error;

  return (
    <div className={`flex flex-col gap-1.5 md:col-span-${colSpan}`}>
      {/* Sem rótulo, não renderiza o <label> vazio — senão o gap do flex desalinha o campo (ex.: dentro de tabelas). */}
      {(label || labelChildren || required) && (
        <label
          htmlFor={htmlFor || id}
          className={`text-sm font-medium ${hasError ? "text-destructive" : "text-foreground/80"}`}>
          {label}
          {labelChildren}
          {required && <span className="text-destructive ml-1">*</span>}
        </label>
      )}

      {/* Input */}
      <InputText
        type={type}
        id={id}
        name={name}
        onChange={onChange}
        onBlur={onBlur}
        value={value ?? ""}
        placeholder={placeholder}
        autoComplete={autoComplete}
        disabled={disabled}
        className={`
          w-full
          h-9
          px-3
          text-sm
          transition-all
          duration-150
          outline-none
          rounded-md
          ${disabled && "bg-muted cursor-not-allowed"}

          ${hasError
            ? "border border-destructive focus:ring-2 focus:ring-destructive/20"
            : "border border-input focus:border-primary focus:ring-2 focus:ring-primary/15"
          }

          ${className}
        `}
      />

      {/* Mensagem abaixo */}
      {hasError ? (
        <span className="text-xs text-destructive">{error}</span>
      ) : helpText ? (
        <span className="text-xs text-muted-foreground">{helpText}</span>
      ) : null}
    </div>
  );
}

export default Input;
